document.addEventListener("DOMContentLoaded", function () {
  const toggles = document.querySelectorAll(".js-footer-toggle");

  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      const submenu = this.nextElementSibling;

      if (submenu.style.maxHeight && submenu.style.maxHeight !== "0px") {
        submenu.style.maxHeight = "0px";
      } else {
        submenu.style.maxHeight = submenu.scrollHeight + "px";
      }

      this.classList.toggle("open");
    });
  });
});

function applyResponsiveFooterWidth() {
  const brandInfos = document.querySelectorAll(".footer-block__brand-info");

  brandInfos.forEach(function (el) {
    const parent = el.parentElement;
    parent.classList.add("custom-width");
  });
}

document.addEventListener("DOMContentLoaded", applyResponsiveFooterWidth);
window.addEventListener("resize", applyResponsiveFooterWidth);

// variant js

// [UPDATED] JavaScript for Custom Dropdown

document.addEventListener("DOMContentLoaded", function () {
  try {
    const customSelects = document.querySelectorAll(
      ".product-form__input--dropdown .select"
    );

    // Check if any dropdowns were found
    if (customSelects.length === 0) {
      console.log(
        "Custom Dropdown: No dropdown elements found with the selector."
      );
      return;
    }

    customSelects.forEach((selectWrapper, index) => {
      const selectElement = selectWrapper.querySelector(".select__select");

      if (selectElement) {
        // Add class on focus (when clicked)
        selectElement.addEventListener("focus", () => {
          console.log(`Dropdown #${index + 1} is focused/opened.`); // Debug message
          selectWrapper.classList.add("is-open");
        });

        // Remove class on blur (when an item is selected or clicked away)
        selectElement.addEventListener("blur", () => {
          console.log(`Dropdown #${index + 1} is blurred/closed.`); // Debug message
          selectWrapper.classList.remove("is-open");
        });
      }
    });
  } catch (e) {
    console.error("Error in custom-dropdown.js:", e);
  }
});

// Equal height function

// Equalize height within a specific section element
function equalizeCardInfoHeights(section) {
  if (!section) return;

  const infoBlocks = section.querySelectorAll(
    ".rr-product-card .product-information"
  );
  if (!infoBlocks.length) return;

  let maxHeight = 0;

  // Reset heights first
  infoBlocks.forEach((block) => {
    block.style.height = "auto";
  });

  // Calculate max height
  infoBlocks.forEach((block) => {
    const height = block.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Apply max height
  infoBlocks.forEach((block) => {
    block.style.height = maxHeight + "px";
  });
}

// All the section classes you want to target
const sectionClasses = [
  ".rr-featured-collection",
  ".rr-featured-product-2",
  ".product-grid-container",
  ".rr-featured-product-3",
];

// Apply equal height logic to each matching section element
function runEqualizersForAllSections() {
  sectionClasses.forEach((selector) => {
    document.querySelectorAll(selector).forEach((section) => {
      equalizeCardInfoHeights(section); // Pass the element directly, not class name
    });
  });
}

// Events
window.addEventListener("load", () => {
  setTimeout(runEqualizersForAllSections, 10);
});

window.addEventListener("resize", () => {
  setTimeout(runEqualizersForAllSections, 10);
});

document.addEventListener("shopify:section:load", () => {
  setTimeout(runEqualizersForAllSections, 10);
});

function syncMobileCheckboxes() {
  const mobileCheckboxes = document.querySelectorAll(
    '#FacetsWrapperMobile input[type="checkbox"]'
  );

  mobileCheckboxes.forEach((checkbox) => {
    const listItem = checkbox.closest(".list-menu__item");
    if (!listItem) return;

    if (checkbox.checked) {
      listItem.classList.add("is-checked");
    } else {
      listItem.classList.remove("is-checked");
    }
  });
}

function initializeMobileFacetListeners() {
  const mobileWrapper = document.getElementById("FacetsWrapperMobile");
  if (!mobileWrapper) return;

  mobileWrapper.addEventListener("click", function (event) {
    const label = event.target.closest(".facets__label");
    if (!label) return;

    const checkbox = label.querySelector('input[type="checkbox"]');
    if (!checkbox) return;
    if (event.target !== checkbox) {
      checkbox.checked = !checkbox.checked;
    }

    syncMobileCheckboxes();
  });

  document.addEventListener("facet:updated", function () {
    setTimeout(syncMobileCheckboxes, 50);
  });

  syncMobileCheckboxes();
}

document.addEventListener("DOMContentLoaded", initializeMobileFacetListeners);

document.addEventListener(
  "shopify:section:load",
  initializeMobileFacetListeners
);

document.addEventListener("DOMContentLoaded", function () {
  const openButtons = document.querySelectorAll(".mobile-facets__open");
  const closeButtons = document.querySelectorAll(".mobile-facets__close");
  let pageOverlay = null;

  function openMenu() {
    if (!pageOverlay) {
      pageOverlay = document.createElement("div");
      pageOverlay.className = "page-overlay";
      pageOverlay.id = "page-overlay";
      document.body.insertBefore(pageOverlay, document.body.firstChild);
      pageOverlay.addEventListener("click", closeMenu);
    }

    const menuContainer = document.querySelector(".disclosure-has-popup");
    if (menuContainer) {
      menuContainer.classList.add("menu-opening");
    }

    setTimeout(() => {
      if (pageOverlay) {
        pageOverlay.classList.add("is-visible");
      }
    }, 10);

    document.body.classList.add("overflow-hidden-mobile");
  }

  function closeMenu() {
    const menuContainer = document.querySelector(
      ".disclosure-has-popup.menu-opening"
    );
    if (menuContainer) {
      menuContainer.classList.remove("menu-opening");
    }

    if (pageOverlay) {
      pageOverlay.classList.remove("is-visible");
      pageOverlay.addEventListener(
        "transitionend",
        function () {
          if (pageOverlay) {
            pageOverlay.remove();
            pageOverlay = null;
          }
        },
        { once: true }
      );
    }

    document.body.classList.remove(
      "cbb-mobile-button",
      "overflow-hidden-mobile"
    );
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", openMenu);
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", closeMenu);
  });
});

function attachDragToScroll(container) {
  if (!container || container.dataset.dragAttached) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  container.addEventListener("mousedown", (e) => {
    isDown = true;
    container.classList.add("active");
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener("mouseleave", () => {
    isDown = false;
    container.classList.remove("active");
  });

  container.addEventListener("mouseup", () => {
    isDown = false;
    container.classList.remove("active");
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 2; // aponar dorkar moto scroll speed change korte paren
    container.scrollLeft = scrollLeft - walk;
  });

  container.dataset.dragAttached = "true";
}

const searchModal = document.querySelector("search-modal.search-modal");
if (searchModal) {
  const observer = new MutationObserver(() => {
    const scroller = document.querySelector(".custom-predictive-scroller");
    if (scroller) {
      attachDragToScroll(scroller);
    }
  });

  observer.observe(searchModal, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function () {
  const menuToggles = document.querySelectorAll(".menu-item-toggle");

  menuToggles.forEach((toggle) => {
    toggle.addEventListener("click", function (event) {
      event.preventDefault();

      const subMenu = this.nextElementSibling;

      this.classList.toggle("is-active");

      if (subMenu.style.height && subMenu.style.height !== "0px") {
        // If open, close it by setting height to 0
        subMenu.style.height = "0px";
      } else {
        subMenu.style.height = subMenu.scrollHeight + "px";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const allMenuContainers = document.querySelectorAll("header-menu");

  allMenuContainers.forEach(function (container) {
    let closeTimer;
    const detailsElement = container.querySelector("details");
    const summaryElement = container.querySelector("summary");

    if (!detailsElement) return;

    container.addEventListener("mouseenter", function () {
      clearTimeout(closeTimer);
      detailsElement.setAttribute("open", "");
    });

    container.addEventListener("mouseleave", function () {
      closeTimer = setTimeout(function () {
        detailsElement.removeAttribute("open");
      }, 250);
    });

    if (summaryElement) {
      summaryElement.addEventListener("click", function (event) {
        event.preventDefault();
      });
    }
  });
});

// Load More Products Functionality
// This script handles the "Load More" button functionality for product grids

document.addEventListener('DOMContentLoaded', () => {
  const loadMoreBtn = document.getElementById('load-more-btn');
  const productGridContainer = document.getElementById('ProductGridContainer');

  if (!loadMoreBtn) {
    return;
  }

  loadMoreBtn.addEventListener('click', function () {
    const button = this;
    const nextUrl = button.dataset.nextUrl;

    button.classList.add('loading');
    button.disabled = true;

    fetch(nextUrl)
      .then(response => response.text())
      .then(text => {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');
        
        const newProducts = htmlDocument.querySelectorAll('#product-grid .grid__item');
        const currentGrid = productGridContainer.querySelector('#product-grid');
        newProducts.forEach(product => {
          currentGrid.appendChild(product);
        });

        const newLoadMoreButton = htmlDocument.getElementById('load-more-btn');
        if (newLoadMoreButton) {
          button.dataset.nextUrl = newLoadMoreButton.dataset.nextUrl;
          // ৫. লোডিং ইফেক্ট বন্ধ করুন
          button.classList.remove('loading');
          button.disabled = false;
        } else {
          button.remove();
        }
      })
      .catch(error => {
        console.error('Error fetching next page:', error);
        button.classList.remove('loading');
        button.disabled = false;
      });
  });
});

